import styled from 'styled-components';

export const LocationSelectorStyles = styled.div`
  .search-location {
    text-align: left;
  }

  .dropdown-list {
    width: 100px;
    display: inline-block;
    padding: 10px 5px;
    top: -1px;

    button {
      cursor: pointer;
    }

    .dropdown-selected-text {
      font-family: 'source-sans-pro', sans-serif;
    }

    .dropdown-chevron {
      top: 23px;
      right: 8px;
      cursor: pointer;
    }

    li span svg {
      top: 10px;
    }
  }

  .error-message {
    height: unset;
  }
`;
